export default "__VITE_ASSET__DRIXgHi5__"